
import React from "react";
import { Schemes } from "../../../../utils";
import { i18nManager } from "../../../../i18n";
import { Elements } from "../../../shared/Elements";
import { Siren } from "../../../shared/ConfirmDialog";
import { Button, Checkbox, Form } from "@rivtn/noseur";
import LoadingGif from "../../../../assets/images/loading_circle.gif";
import { BaseService, IMember, IProfileWebsite, ITeam, ITeamWebsite, MemberService, SanitizedResponse, TeamService } from "../../../../services";

export interface ActivitiesProps {
    team: ITeam;
    profile: IMember;
    teamWebsite: ITeamWebsite;
}

function Activities(props: ActivitiesProps) {

    const { team } = props;
    const teamService = TeamService.getInstance();
    const labels = i18nManager.Labels.teams.settings.activities;
    const [teamWebsite, setTeamWebsite] = React.useState<ITeamWebsite>(props.teamWebsite);

    return (<Form scheme={Schemes.OMNEHOST} className="profile-settings team-settings">
        <Checkbox label={labels.enable_ad} defaultChecked={teamWebsite?.activities_settings?.enable_rivtn_ad} onChecked={(checked) => {
            setTeamWebsite({ ...teamWebsite, activities_settings: { ...teamWebsite.activities_settings, enable_rivtn_ad: checked } });
        }} />
        <hr />
        <Checkbox label={labels.show_trophies} defaultChecked={teamWebsite?.activities_settings?.show_trophies} onChecked={(checked) => {
            setTeamWebsite({ ...teamWebsite, activities_settings: { ...teamWebsite.activities_settings, show_trophies: checked } });
        }}  />
        <span style={{ fontWeight: "bold", margin: "10px 0px" }}>{labels.tournaments}</span>
        <Checkbox label={labels.show_trails} defaultChecked={teamWebsite?.activities_settings?.show_tournament_trails} onChecked={(checked) => {
            setTeamWebsite({ ...teamWebsite, activities_settings: { ...teamWebsite.activities_settings, show_tournament_trails: checked } });
        }}  />
        <Checkbox label={labels.show_graphs} defaultChecked={teamWebsite?.activities_settings?.show_tournament_graphs} onChecked={(checked) => {
            setTeamWebsite({ ...teamWebsite, activities_settings: { ...teamWebsite.activities_settings, show_tournament_graphs: checked } });
        }}  />
        <span style={{ fontWeight: "bold", margin: "10px 0px" }}>{labels.activities}</span>
        <Checkbox label={labels.show_trails} defaultChecked={teamWebsite?.activities_settings?.show_activities_trails} onChecked={(checked) => {
            setTeamWebsite({ ...teamWebsite, activities_settings: { ...teamWebsite.activities_settings, show_activities_trails: checked } });
        }}  />
        <Checkbox label={labels.show_graphs} defaultChecked={teamWebsite?.activities_settings?.show_activities_graph} onChecked={(checked) => {
            setTeamWebsite({ ...teamWebsite, activities_settings: { ...teamWebsite.activities_settings, show_activities_graph: checked } });
        }}  />
        <span style={{ fontWeight: "bold", margin: "10px 0px" }}>{labels.members}</span>
        <Checkbox label={labels.show_trails} defaultChecked={teamWebsite?.activities_settings?.show_members_trails} onChecked={(checked) => {
            setTeamWebsite({ ...teamWebsite, activities_settings: { ...teamWebsite.activities_settings, show_members_trails: checked } });
        }}  />
        <Checkbox label={labels.show_graphs} defaultChecked={teamWebsite?.activities_settings?.show_members_graphs} onChecked={(checked) => {
            setTeamWebsite({ ...teamWebsite, activities_settings: { ...teamWebsite.activities_settings, show_members_graphs: checked } });
        }}  />
        <span style={{ fontWeight: "bold", margin: "10px 0px" }}>{labels.timeline}</span>
        <Checkbox label={labels.show_trails} defaultChecked={teamWebsite?.activities_settings?.show_timeline_trails} onChecked={(checked) => {
            setTeamWebsite({ ...teamWebsite, activities_settings: { ...teamWebsite.activities_settings, show_timeline_trails: checked } });
        }}  />
        <Checkbox label={labels.show_graphs} defaultChecked={teamWebsite?.activities_settings?.show_timeline_graph} onChecked={(checked) => {
            setTeamWebsite({ ...teamWebsite, activities_settings: { ...teamWebsite.activities_settings, show_timeline_graph: checked } });
        }}  />
        <span style={{ fontWeight: "bold", margin: "10px 0px" }}>{labels.achievements}</span>
        <Checkbox label={labels.show_trails} defaultChecked={teamWebsite?.activities_settings?.show_achievements_trails} onChecked={(checked) => {
            setTeamWebsite({ ...teamWebsite, activities_settings: { ...teamWebsite.activities_settings, show_achievements_trails: checked } });
        }}  />
        <Checkbox label={labels.show_graphs} defaultChecked={teamWebsite?.activities_settings?.show_achievements_graphs} onChecked={(checked) => {
            setTeamWebsite({ ...teamWebsite, activities_settings: { ...teamWebsite.activities_settings, show_achievements_graphs: checked } });
        }} />
        <Button scheme={Schemes.OMNEHOST} text={i18nManager.Labels.common.save_changes} loadingProps={Elements.BUTTON_LOADING_PROPS}
            style={{ marginTop: 20 }} onClick={(e) => {
                e.manageRef?.setLoadingState(true);
                updateTeamWebsite(() => e.manageRef?.setLoadingState(false));
            }} />
    </Form>);

    function updateTeamWebsite(onDone?: () => void) {
        teamService.updateTeamWebsite(team.external_id, teamWebsite!).then(({ sanitized }: SanitizedResponse<ITeamWebsite>) => {
            setTeamWebsite(sanitized);
            Siren.alert(labels.update_successful);
        }).catch(BaseService.reportError).finally(onDone);
    }

}

export default Activities;
